import { getApiUrl } from "../api";
import { useEffect, useState } from "react";
import Preloader from "../component/Preloader";
import Header from "../component/Header";
import LanguagePopup from "../component/LanguagePopup";
import Footer from "../component/Footer";
import FloatingWidgets from "../component/FloatingWidgets";
import HomeModals from "../component/HomeModals";
import useHomeInteractions from "../component/useHomeInteractions";
import { Link } from "../component/AppLink";
import { getCloudflareImageUrl } from "../utils/cloudflareImages";
import { ArabicHeader, ArabicFooter } from "./ArabicHome";

const getJwtToken = () => {
  const keys = ["token", "accessToken", "jwt", "authToken"];
  for (const key of keys) {
    const token = localStorage.getItem(key) || sessionStorage.getItem(key);
    if (token?.trim()) return token.replace(/^Bearer\s+/i, "").trim();
  }

  return (process.env.REACT_APP_JWT_TOKEN || "").replace(/^Bearer\s+/i, "").trim();
};


const stripHtml = (value) => String(value || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();

const mapStructure = (item, language = "en") => ({
  id: item?.id || "",
  title: stripHtml(language === "ar" ? item?.title_ar || item?.title || item?.title_en : item?.title_en || item?.title),
  image: getCloudflareImageUrl(item?.ImagePath || item?.image || item?.imagePath, "w=1900,sharpen=1"),
});

export default function OrganizationStructure({ language = "en" }) {
  const interactions = useHomeInteractions();
  const [structure, setStructure] = useState({});

  useEffect(() => {
    document.title = "Organization Structure | Tarahum Charity Foundation";
  }, []);

  useEffect(() => {
    const controller = new AbortController();

    const loadStructure = async () => {
      try {
        const headers = { Accept: "application/json" };
        const token = getJwtToken();
        if (token) {
          headers.Authorization = `Bearer ${token}`;
        }

        const response = await fetch(getApiUrl("/api/GetOrganizationStructureList.ashx?page=1&pageSize=1"), {
          headers,
          credentials: "include",
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error(`Organization structure request failed with ${response.status}`);
        }

        const result = await response.json();
        const row = Array.isArray(result?.data) ? result.data[0] : null;

        if (row) {
          setStructure(mapStructure(row, language));
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.warn("Unable to load organization structure", error);
        }
      }
    };

    loadStructure();

    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (language !== "ar") return undefined;
    document.documentElement.lang = "ar";
    document.documentElement.dir = "rtl";
    document.body.classList.add("arabic-layout-page");
    return () => { document.body.classList.remove("arabic-layout-page"); document.documentElement.lang = "en"; document.documentElement.dir = "ltr"; };
  }, [language]);

  return (
    <>
      <Preloader />
      {language === "ar" ? <ArabicHeader /> : <Header />}
      {language === "ar" ? null : <LanguagePopup />}

      <section className="kid-d-wrp pb-0">
        <div className="kid-container">
          <div className="kid-hero">
            <h1>{language === "ar" ? "الهيكل التنظيمي" : "Organization Structure"}</h1>
            <ul className="kid-breadcrumb">
              <li>
                <Link to="/">{language === "ar" ? "الرئيسية" : "home"}</Link>
              </li>
              <li>/</li>
              <li>{language === "ar" ? "الهيكل التنظيمي" : "Organization Structure"}</li>
            </ul>
          </div>
        </div>
      </section>

      <div className="page-team">
        <div className="container">
          <div>
            <img
              src={structure.image}
              alt={structure.title}
              width="100%"
              onError={(event) => {
                event.currentTarget.style.display = "none";
              }}
            />
          </div>
        </div>
      </div>

      {language === "ar" ? <ArabicFooter /> : <Footer />}
      <FloatingWidgets {...interactions} />
      <HomeModals {...interactions} />
    </>
  );
}
